import store from '@/state/store'
const hasAccess = store.getters['identity/hasAccess']

export const general = [
  {
    id: 1,
    alertCode: [11],
    title: 'global.alert.sosButton',
    scope: null,
    hasSetting: false,
  },
  {
    id: 2,
    alertCode: [1],
    title: 'global.alert.gpsDisarmed',
    scope: null,
    hasSetting: false,
  },
  {
    id: 3,
    alertCode: [18],
    title: 'notification.alert.engineTemp',
    scope: hasAccess(['z1b-itemp:read']),
    hasSetting: false,
    url: '/#',
  },
  {
    id: 4,
    alertCode: [2],
    title: 'notification.alert.deviceLowPower',
    scope: null,
    hasSetting: false,
  },
  {
    id: 5,
    alertCode: [3],
    title: 'notification.alert.signal',
    scope: null,
    hasSetting: false,
  },
  {
    id: 6,
    alertCode: [10],
    title: 'notification.alert.vibration',
    scope: null,
    hasSetting: false,
  },
  {
    id: 7,
    alertCode: [12],
    title: 'notification.alert.engine',
    scope: null,
    hasSetting: false,
  },
  {
    id: 8,
    alertCode: [7],
    title: 'notification.alert.geolocation',
    scope: null,
    hasSetting: false,
  },
  {
    id: 9,
    alertCode: [13, 14],
    title: 'notification.alert.fuel',
    scope: hasAccess(['z1d-fuelultrasonic:read', 'z1e-itank:read']),
    hasSetting: true,
    url: 'Fuel Sensor Setting',
  },
  {
    id: 10,
    alertCode: [62, 63],
    title: 'global.alert.pto',
    scope: hasAccess(['z1l-pto:read']),
    hasSetting: false,
  },
  {
    id: 11,
    alertCode: [4, 19],
    title: 'notification.alert.door1',
    scope: hasAccess(['z1f-idoor:read']),
    hasSetting: false,
  },
  {
    id: 12,
    alertCode: [5, 20],
    title: 'notification.alert.door2',
    scope: hasAccess(['z1f-idoor:read']),
    hasSetting: false,
  },
  {
    id: 13,
    alertCode: [75],
    title: 'global.alert.missRoute',
    scope: hasAccess(['d7a-default-md-route:read']),
    hasSetting: false,
  },
  {
    id: 14,
    alertCode: [15],
    title: 'notification.alert.idleTime',
    scope: hasAccess(['notif_idle_parking:read']),
    hasSetting: true,
    url: 'Idle & Parking Limit Times',
  },
  {
    id: 15,
    alertCode: [16],
    title: 'notification.alert.parkTime',
    scope: hasAccess(['notif_idle_parking:read']),
    hasSetting: true,
    url: 'Idle & Parking Limit Times',
  },
  {
    id: 16,
    alertCode: [36],
    title: 'notification.alert.coverRemoved',
    scope: hasAccess(['notif_covered_remove:read']),
    hasSetting: false,
  },
  {
    id: 17,
    alertCode: [17],
    title: 'notification.alert.temperature',
    scope: hasAccess(['notif_refrigerator:read']),
    hasSetting: false,
  },
  {
    id: 18,
    alertCode: [21, 22],
    title: 'notification.alert.refrigerator',
    scope: hasAccess(['z1b-itemp:read']),
    hasSetting: false,
    url: '/#',
  },
  {
    id: 19,
    alertCode: [94, 95],
    title: 'notification.alert.crashDetection',
    scope: hasAccess(['teltonika-device:read']),
    hasSetting: false,
  },
  {
    id: 20,
    alertCode: [117],
    title: 'notification.alert.drivingTime',
    scope: null,
    hasSetting: false,
  },
  {
    id: 21,
    alertCode: [118],
    title: 'notification.alert.deviceOffline',
    scope: null,
    hasSetting: false,
  },
  {
    id: 22,
    alertCode: [93],
    label: 'notification.alert.gpsJammerDetected',
    category: 'global.alert.type.general',
    scope: hasAccess(['e1m-general-jammer-detection:read']),
    hasSetting: false,
  },
  {
    id: 23,
    alertCode: [88],
    label: 'notification.alert.gsmJammerDetected',
    category: 'global.alert.type.general',
    scope: hasAccess(['e1m-general-jammer-detection:read']),
    hasSetting: false,
  },
  {
    id: 24,
    alertCode: [123],
    label: 'notification.alert.storageUnavailable',
    category: 'global.alert.type.general',
    scope: hasAccess(['e1p-general-storage-unavailable:read']),
    hasSetting: false,
  },
  {
    id: 25,
    alertCode: [126],
    label: 'notification.alert.cameraOff',
    category: 'global.alert.type.general',
    scope: hasAccess(['e1o-general-camera-offline:read']),
    hasSetting: false,
  },
]

export const dms = [
  {
    id: 1,
    alertCode: [53],
    title: 'notification.field.sleepy',
    scope: null,
    hasSetting: false,
  },
  {
    id: 2,
    alertCode: [52],
    title: 'notification.alert.disturbance',
    scope: null,
    hasSetting: false,
  },
  {
    id: 3,
    alertCode: [54],
    title: 'global.alert.smoking',
    scope: null,
    hasSetting: false,
  },
  {
    id: 4,
    alertCode: [55],
    title: 'notification.field.calling',
    scope: null,
    hasSetting: false,
  },
  {
    id: 5,
    alertCode: [51],
    title: 'notification.field.eyesClosed',
    scope: null,
    hasSetting: false,
  },
  {
    id: 6,
    alertCode: [56],
    title: 'notification.alert.outframe',
    scope: null,
    hasSetting: false,
  },
  {
    id: 7,
    alertCode: [110],
    title: 'global.alert.seatbelt',
    scope: hasAccess(['seat_belt_alert:read']),
    hasSetting: false,
  },
  {
    id: 8,
    alertCode: [50],
    title: 'global.alert.fatigueDriving',
    scope: hasAccess(['fatigue_driving_alert:read']),
    hasSetting: false,
  },
  {
    id: 9,
    alertCode: [49],
    title: 'global.alert.crash',
    scope: true,
    hasSetting: false,
  },
  {
    id: 10,
    alertCode: [111],
    title: 'global.alert.infraredBlocked',
    scope: hasAccess(['infrared_blocked_alert:read']),
    hasSetting: false,
  },
  {
    id: 11,
    alertCode: [112],
    label: 'notification.alert.cameraBlocked',
    category: 'global.alert.type.dms',
    scope: null,
    hasSetting: false,
  },
  {
    id: 12,
    alertCode: [150],
    label: 'notification.alert.driverUnrecognized',
    category: 'global.alert.type.dms',
    scope: hasAccess(['e1n-dms-driver-unrecognized:read']),
    hasSetting: false,
  },
  {
    id: 13,
    alertCode: [148],
    label: 'notification.alert.driverIdentified',
    category: 'global.alert.type.dms',
    scope: hasAccess(['e1n-dms-driver-unrecognized:read']),
    hasSetting: false,
  },
  {
    id: 14,
    alertCode: [149],
    label: 'notification.alert.driverDetected',
    category: 'global.alert.type.dms',
    scope: hasAccess(['e1n-dms-driver-unrecognized:read']),
    hasSetting: false,
  },
  {
    id: 15,
    alertCode: [152],
    label: 'notification.alert.driverChanged',
    category: 'global.alert.type.dms',
    scope: hasAccess(['e1n-dms-driver-unrecognized:read']),
    hasSetting: false,
  },
]

export const driverBehavior = [
  {
    id: 1,
    alertCode: [24],
    title: 'global.alert.suddenAcceleration',
    scope: null,
    hasSetting: false,
    url: '/#',
  },
  {
    id: 2,
    alertCode: [23],
    title: 'global.alert.suddenDeceleration',
    scope: null,
    hasSetting: false,
    url: '/#',
  },
  {
    id: 3,
    alertCode: [8],
    title: 'notification.alert.overspeed',
    scope: null,
    hasSetting: false,
    url: '/#',
  },
  {
    id: 4,
    alertCode: [25],
    title: 'global.alert.sharpTurn',
    scope: null,
    hasSetting: false,
  },
]

export const adas = [
  {
    id: 1,
    alertCode: [90],
    title: 'global.alert.forwardCollison',
    scope: null,
    hasSetting: false,
  },
  {
    id: 2,
    alertCode: [92],
    title: 'global.alert.laneDeparture',
    scope: null,
    hasSetting: false,
  },
  {
    id: 3,
    alertCode: [91],
    title: 'global.alert.headwayMonitor',
    scope: null,
    hasSetting: false,
  },
  {
    id: 4,
    alertCode: [113],
    title: 'global.alert.frontObjectDetected',
    scope: hasAccess(['front_object_detected_alert:read']),
    hasSetting: false,
  },
]

export const cdm = [
  {
    key: 'motionDetected',
    alertCode: [122],
    label: 'global.alert.motionDetected',
    category: 'global.alert.type.cdm',
    scope: hasAccess(['e1q-brinks-cdm:read']),
    hasSetting: false,
  },
  {
    key: 'movement',
    alertCode: [127],
    label: 'global.alert.movement',
    category: 'global.alert.type.cdm',
    scope: hasAccess(['e1q-brinks-cdm:read']),
    hasSetting: false,
  },
  {
    key: 'buzzerFaulty',
    alertCode: [128],
    label: 'global.alert.buzzerFaulty',
    category: 'global.alert.type.cdm',
    scope: hasAccess(['e1q-brinks-cdm:read']),
    hasSetting: false,
  },
  {
    key: 'motionFaulty',
    alertCode: [129],
    label: 'global.alert.motionFaulty',
    category: 'global.alert.type.cdm',
    scope: hasAccess(['e1q-brinks-cdm:read']),
    hasSetting: false,
  },
]
